/* unplugin-vue-components disabled */import { render } from "./app.vue?vue&type=template&id=4e43859e"
import script from "./app.vue?vue&type=script&lang=js"
export * from "./app.vue?vue&type=script&lang=js"

import "./app.vue?vue&type=style&index=0&id=4e43859e&lang=scss"
script.render = render

export default script